/**
 * 人脉库
 */
import React, { useEffect } from 'react';

export default function () {

  useEffect(() => {
    switch (process.env.REACT_APP_ENV) {
      case 'dev':
        window.open('https://yun-dev.ywwl.com/customerManage/DM768DBD75EE80742443587095628220/_customerManage_list', '_blank');
        break;
      case 'test':
        window.open('https://yun-test.ywwl.com/customerManage/DMD3748F2D9078127785776136664700/_customerManage_list', '_blank');
        break;
      default:
        window.open('https://yun.ywwl.com/customerManage/DMD3748F2D9078127785776136664700/_customerManage_list', '_blank')
    }
  });

  return (
    <></>
  )
}
